import { ComponentType, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useTheme, useUser } from '~/hooks';
import { resolveSyncedTheme } from '~/utils/themeHelper';

export const withGlobalUserSettings = (WrappedComponent: ComponentType) => () => {
  const user = useUser();
  const userLanguage = user?.details.language;
  const userTheme = user?.details.theme;

  const { i18n } = useTranslation();
  const { storedTheme, setTheme } = useTheme();

  /**
   * Keyed off the profile alone on purpose: `storedTheme` is read as it was when the profile
   * arrived, so a theme picked later in the session is not synced back over.
   */
  useEffect(() => {
    // TODO: Current user details don't include language preference, default to English for now
    const currentLanguage = 'en'; // currentUser?.details?.language

    if (currentLanguage !== userLanguage) {
      i18n.changeLanguage(currentLanguage);
    }

    const syncedTheme = resolveSyncedTheme({ userTheme, storedTheme });

    if (syncedTheme) {
      setTheme(syncedTheme);
    }
  }, [userLanguage, userTheme]);

  return <WrappedComponent />;
};
